/** Rubriques du passage infirmerie — ordre d’affichage ; une seule ou plusieurs selon le besoin. */
export const NURSE_PASSAGE_SECTIONS = [
  { id: 'acts', label: 'Soins & tests', icon: 'pills' },
  { id: 'vitals', label: 'Constantes', icon: 'chartBar' },
  { id: 'exam', label: 'Examen', icon: 'stethoscope' }
];

export const NURSE_PASSAGE_SECTION_ORDER = NURSE_PASSAGE_SECTIONS.map((section) => section.id);

export function getPassageSectionLabel(sectionId) {
  return NURSE_PASSAGE_SECTIONS.find((section) => section.id === sectionId)?.label || '';
}
